// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileList-cls1___04910be246b1e955f1a","cls2":"ProfileList-cls2__ca98ebdda76b0f2a529e ProfileList-cls1___04910be246b1e955f1a"};